import { FunctionComponent } from 'react';

export const BundledChangesContent: FunctionComponent = () => {
  return null;
};
